import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
/* components */
import AuthWrapper from '../../components/auth-wrapper/auth-wrapper';
import Input from '../../components/input/input';
import Validation from '../../components/validation/validation';

function LoginPage(props) {
    const [email, setEmail] = useState(props.model.username || '');
    const [password, setPassword] = useState('');
    const loginForm = useRef();

    useEffect(() => {
        if (props.model.errors.length > 0 && loginForm.current) {
            loginForm.current.showError('Username', () => '');
            loginForm.current.showError('Password', () => props.model.errors[0].messages.join(';'));
            loginForm.current.validateAll();
        }
    }, [props.model.errors]);

    const handleEmailChange = useCallback(value => {
        loginForm.current.hideError('Username');
        loginForm.current.hideError('Password');
        setEmail(value.trim());
    }, [setEmail]);

    const handlePasswordChange = useCallback(value => {
        loginForm.current.hideError('Username');
        loginForm.current.hideError('Password');
        setPassword(value.trim());
    }, [setPassword]);

    /**
     * Long time ago in a galaxy far far away...
     * There was Facebook framework called React and...
     * There was Google Web Browser called Chrome...
     * They didn't know for each other, didn't had love and understanding for each other...
     * They even didn't know how to communicate so we made this AI code in other to translate
     * understanding between them, in behalf of humans.
     *
     * This code will force time spare 10ms in order to collect data from browsers autocomplete form and propagate
     * to React state where humans will use that values and send to outer space (a.k.a = API)
     *
     * So long and thanks for all the fish!
     */

    const beforeSubmit = new Promise(resolve => (
        setTimeout(() => (
            resolve()
        ), 10)
    ));

    const renderExternalProviders = (externalProviders) => {
        return (
            <React.Fragment>
                {externalProviders.map(provider => (
                    <section className="sten-content__section" key={provider.displayName}>
                        <a
                            className="btn btn--primary btn--sm col-24"
                            href={`/External/Challenge?provider=${
                                provider.authenticationScheme}&returnUrl=${
                                encodeURIComponent(props.model.returnUrl || '/')}`}
                        >
                            {provider.displayName}
                        </a>
                    </section>
                ))}
                {props.model.enableLocalLogin && (
                    <div className="sten-content__subtitle sten-content__subtitle--pass-through">or</div>
                )}
            </React.Fragment>
        );
    };

    const hasExternalProviders = props.model.externalProviders && props.model.externalProviders.length > 0;

    return (
        <AuthWrapper heading="Welcome!">
            {hasExternalProviders && renderExternalProviders(props.model.externalProviders)}
            {props.model.enableLocalLogin && (
                <Validation.Form method="post" ref={loginForm} resolveBeforeSubmit={beforeSubmit}>
                    <input type="hidden" name="ReturnUrl" value={props.model.returnUrl || ''} />
                    <section className="sten-content__section">
                        <Validation.Wrapper validations={{ required: true, email: true }}>
                            <Input
                                name="Username"
                                className="sten-input--sm"
                                type="text"
                                id="Username"
                                placeholder="Email"
                                value={email}
                                onChange={handleEmailChange}
                                showKeyboard
                            />
                        </Validation.Wrapper>
                    </section>
                    <section className="sten-content__section">
                        <Validation.Wrapper validations={{ required: true }}>
                            <Input
                                name="Password"
                                className="sten-input--sm"
                                type="password"
                                id="Password"
                                placeholder="Password"
                                value={password}
                                onChange={handlePasswordChange}
                                showKeyboard
                            />
                        </Validation.Wrapper>
                    </section>
                    <section className="sten-content__section">
                        <Validation.Button
                            className="btn btn--secondary btn--sm col-24"
                            value="login"
                        >
                            Login
                        </Validation.Button>
                    </section>
                    <section className="sten-content__section">
                        <div className="text-center">
                            <a
                                className="sten-link"
                                href={`/Account/ForgotPassword?ReturnUrl=${
                                    encodeURIComponent(props.model.returnUrl || '/')}`}
                            >
                                Forgot password?
                            </a>
                        </div>
                    </section>
                    <input name="__RequestVerificationToken" type="hidden" value={props.token} />
                </Validation.Form>
            )}
            {!props.model.enableLocalLogin && !hasExternalProviders && (
                <section className="sten-content__section">
                    <strong>Invalid login request</strong>
                    <p>There are no login schemes configured for this client.</p>
                    <p>Please contact your administrator.</p>
                </section>
            )}
        </AuthWrapper>
    );
}

LoginPage.propTypes = {
    token: PropTypes.string.isRequired,
    model: PropTypes.objectOf(PropTypes.any).isRequired
};

export default LoginPage;
